import { UserCircle, KeyRound, Receipt, Wallet, CreditCard, FileText } from "lucide-react";

export const studentNavData = [
  {
    category: "ACCOUNT & GENERAL",
    items: [
      { title: "My Profile", icon: UserCircle, url: "/student-panel/profile" },
      { title: "Change Password", icon: KeyRound, url: "/student-panel/change-password" },
      { title: "My Results", icon: Receipt, url: "/student-panel/results" },
      { title: "Report Cards", icon: FileText, url: "/student-panel/report-cards" },
    ]
  },
  {
    category: "FEES & PAYMENTS",
    items: [
      { title: "Fee Ledger", icon: Wallet, url: "/student-panel/fees/ledger" },
      { title: "My Receipts", icon: Receipt, url: "/student-panel/fees/receipts" },
      { title: "Pay Fees", icon: CreditCard, url: "/student-panel/fees/pay" },
    ]
  }
];